import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const notifications = [{
  name: 'Mariana López',
  city: 'Buenos Aires',
  avatar: 'https://randomuser.me/api/portraits/women/44.jpg',
  time: '3 minutos'
}, {
  name: 'Carolina Méndez',
  city: 'Córdoba',
  avatar: 'https://randomuser.me/api/portraits/women/65.jpg',
  time: '7 minutos'
}, {
  name: 'Patricia Sosa',
  city: 'Rosario',
  avatar: 'https://randomuser.me/api/portraits/women/22.jpg',
  time: '12 minutos'
}, {
  name: 'Laura Giménez',
  city: 'Mendoza',
  avatar: 'https://randomuser.me/api/portraits/women/33.jpg',
  time: '5 minutos'
}, {
  name: 'Silvina Ruiz',
  city: 'La Plata',
  avatar: 'https://randomuser.me/api/portraits/women/55.jpg',
  time: '9 minutos'
}, {
  name: 'Andrea Pereyra',
  city: 'Mar del Plata',
  avatar: 'https://randomuser.me/api/portraits/women/12.jpg',
  time: '4 minutos'
}, {
  name: 'Romina Acuña',
  city: 'Tucumán',
  avatar: 'https://randomuser.me/api/portraits/women/77.jpg',
  time: '11 minutos'
}, {
  name: 'Verónica Ledesma',
  city: 'Salta',
  avatar: 'https://randomuser.me/api/portraits/women/8.jpg',
  time: '6 minutos'
}];
export function SocialProofPopup() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const showNotification = () => {
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % notifications.length);
      showNotification();
    }, 10000);
    // Show first notification after 3 seconds
    setTimeout(showNotification, 3000);
    return () => clearInterval(interval);
  }, []);
  const current = notifications[currentIndex];
  return <AnimatePresence data-id="element-186">
      {isVisible && <motion.div initial={{
      x: -400,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -400,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 100
    }} className="fixed bottom-6 left-6 z-50 bg-white rounded-xl shadow-2xl p-4 max-w-sm border border-[#2D6A4F]/30" data-id="element-187">
          <div className="flex items-center gap-4" data-id="element-188">
            <img src={current.avatar} alt={current.name} className="w-12 h-12 rounded-full object-cover border border-gray-200" data-id="element-189" />
            <div className="flex-1" data-id="element-190">
              <div className="flex items-center gap-1.5" data-id="element-191">
                <p className="font-bold text-sm text-[#1F3A5F]" data-id="element-192">
                  {current.name}
                </p>
                <CheckCircle2 size={14} className="text-[#2D6A4F]" data-id="element-193" />
              </div>
              <p className="text-sm text-gray-700 mt-0.5" data-id="element-194">
                ha adquirido su manual
              </p>
              <p className="text-xs text-gray-400 mt-1 italic" data-id="element-195">
                {current.city} · hace {current.time}
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}